export default [
  {
    path: '/admin/configuration',
    name: 'admin-configuration',
    component: () => import('@/views/admin/configuration/Configuration.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Configuration',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Configuration',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/industries',
    name: 'admin-industries',
    component: () => import('@/views/admin/configuration/Industries.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Industries',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Industries',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/languages',
    name: 'admin-languages',
    component: () => import('@/views/admin/configuration/Languages.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Languages',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Languages',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/languages/translate/:id',
    name: 'admin-languages-translate',
    component: () => import('@/views/admin/configuration/TranslateLanguages.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Languages.TranslateLanguages',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Languages',
          to: '/admin/languages',
        },
        {
          text: 'Admin.SideMenu.Navigation.Languages.TranslateLanguages',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/scoring/multipliers',
    name: 'admin-scoring-multipliers',
    component: () => import('@/views/admin/configuration/ScoringMultipliers.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.ScoringMultipliers',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.ScoringMultipliers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/bid',
    name: 'admin-bid-strategy-subtype-mappings',
    component: () => import('@/views/admin/configuration/BidStrategiesSubtypeMappings.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.BidStrategiesSubtypeMappings',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.BidStrategiesSubtypeMappings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/preset',
    name: 'table-preset',
    component: () => import('@/views/admin/configuration/TablePresets.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.TablePresets',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.TablePresets',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/emails',
    name: 'admin-emails',
    component: () => import('@/views/admin/configuration/Emails.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Emails',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Emails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/emails/edit/:id',
    name: 'admin-emails-edit',
    component: () => import('@/views/admin/configuration/EmailTemplate.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Emails.EditEmail',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Emails',
          to: '/admin/emails',
        },
        {
          text: 'Admin.SideMenu.Navigation.EditEmail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/targeting',
    name: 'admin-targeting',
    component: () => import('@/views/admin/configuration/TargetingProperties.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Configuration.TargetingProperties',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Configuration.TargetingProperties',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/info',
    name: 'admin-info',
    component: () => import('@/views/admin/configuration/Info.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Configuration.Info',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Configuration.Info',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/info/sectiongroup/:id',
    name: 'admin-info-sectiongroup',
    component: () => import('@/views/admin/configuration/SectionGroup.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Configuration.Info.SectionGroup',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Configuration.Info',
          to: '/admin/info',
        },
        {
          text: 'Admin.SideMenu.Configuration.Info.SectionGroup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/info/:groupId/section/:id',
    name: 'admin-info-sectionInfo',
    component: () => import('@/views/admin/configuration/SectionInfo.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Configuration.Info.SectionInfo',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Configuration.Info',
          to: '/admin/info',
        },
        {
          text: 'Admin.SideMenu.Configuration.Info.SectionGroup',
        },
        {
          text: 'Admin.SideMenu.Configuration.Info.SectionInfo',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumb[2].to = `/admin/info/sectiongroup/${to.params.groupId}`
      next()
    },
  },
]
